import React from "react";
import { formatReportDate } from "../utils/reportDate";
import "./DealInfoPanel.css";

const pendingStatusMap = {
  1: "Purchase Contract",
  2: "Sales Contract",
  3: "Advance Payment",
  4: "Shipment Schedule",
  5: "Document Pending",
  6: "Final Payment Pending",
  7: "Container Release"
};

const formatDate = (value) => formatReportDate(value, "");
const formatAmount = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const amount = Number(value);
  return Number.isFinite(amount)
    ? amount.toLocaleString(undefined, { maximumFractionDigits: 4 })
    : String(value);
};

const formatPriceAdjustments = (value) => String(value)
  .split(", ")
  .map((adjustment) => adjustment
    .replace(/^%\s*(.+)$/, "$1 %")
    .replace(/([+-]?\d+(?:\.\d+)?)\s*%/g, (_, amount) => `${Number(amount).toFixed(2)}%`))
  .join(", ");

const getPriceDisplay = (deal) => {
  const adjustments = String(deal.UnfixedPriceDetails || "").trim();
  const isUnfixed = Boolean(adjustments) ||
    String(deal.PriceMode || "").toLowerCase() === "unfixed";

  if (isUnfixed) {
    const fallback = formatPriceAdjustments(formatAmount(deal.UnFixedAmount));
    const formattedAdjustments = formatPriceAdjustments(adjustments);
    return `Unfixed${formattedAdjustments ? ` - ${formattedAdjustments}` : fallback ? ` - ${fallback}` : ""}`;
  }

  const fixedAmount = formatAmount(deal.FixedAmount);
  const currency = deal.DealCurrency || "USD";
  return fixedAmount ? `Fixed - ${currency} ${fixedAmount}` : "Fixed";
};

const DealInfoPanel = ({ deal = {}, show = true, onToggle }) => {
  const dealNoDate = `${deal.DealNo || deal.DealID || ""}${deal.DealDate ? ` - ${formatDate(deal.DealDate)}` : ""}`;
  const scNo = deal.SCRNo || deal.SCNo || "";
  const scNoDate = scNo
    ? `${scNo}${deal.SCRDate ? ` - ${formatDate(deal.SCRDate)}` : ""}`
    : "";
  const statusText =
    deal.Status || deal.PendingStatusName || pendingStatusMap[Number(deal.PendingStatus)] || "DOC RELEASE";

  const fields = [
    { label: "Deal No - Date", value: dealNoDate },
    { label: "Supplier", value: deal.ShipperName || "" },
    { label: "Buyer", value: deal.BuyerName || "" },
    { label: "S.C No - Date", value: scNoDate, status: statusText },
    { label: "Material Name", value: deal.MaterialName || "" },
    { label: "No. Of Container", value: deal.NoOfContainer || "" },
    { label: "Qty", value: deal.TotalQty || "" },
    { label: "Price", value: getPriceDisplay(deal) }
  ];

  return (
    <div className="border rounded bg-white mb-3">
      <div
        className="px-3 py-2 border-bottom fw-bold text-muted d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer" }}
        onClick={onToggle}
      >
        <span className="me-auto">View Deal Info</span>
        <span>{show ? "^" : "v"}</span>
      </div>

      {show && (
        <div className="p-3">
          <div className="deal-info-grid">
            {fields.map((field) => (
              <div className="deal-info-field" key={field.label}>
                {field.status && (
                  <div className="deal-info-status-row">
                    <span className="badge bg-warning text-dark deal-info-status-badge">
                      {field.status}
                    </span>
                  </div>
                )}
                <label className="form-label fw-semibold">{field.label}</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={field.value}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DealInfoPanel;
